import { Component, inject, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ModalService } from '../../../../services/modals/modal.service';
import { Router, RouterModule } from '@angular/router';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-become-sponsor-success-page',
  imports: [ButtonModule, RouterModule],
  templateUrl: './become-sponsor-success-page.component.html',
  styleUrl: './become-sponsor-success-page.component.scss'
})
export class BecomeSponsorSuccessPageComponent implements OnInit {

  auctionId!: number;

  constructor(public config: DynamicDialogConfig, private router: Router) {
    this.auctionId = config.data.auctionId;
  }

  private readonly modalService = inject(ModalService);

  ngOnInit(): void {
    // console.log(this.auctionId)
  }

  onClose() {
    this.modalService.closeModal('become-sponsor-success');
    this.router.navigate(['/auction', this.auctionId]);
  }

}
